



































































import Vue from "vue";
import { Meldung } from "@/types";

/**
 * Emits @read set as read event
 * Emits @click onclick event
 */
export default Vue.extend({
  name: "TableContainer",
  props: {
    meldungen: {
      type: Array as () => Meldung[],
      default: undefined,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick(meldung: Meldung) {
      this.$emit("click", meldung);
    },
    setAsRead(meldung: Meldung) {
      this.$emit("read", meldung);
    },
  },
});
